import { triadSuperFetch } from 'utils/superFetch';
import { useState } from 'react';
import { WordPress, APIs } from '../common/Icons';
import styles from '../ConfigModal.module.css';

export function UtilsSection(): React.JSX.Element {
  const [isLoading, setIsLoading] = useState(false);
  const [landingPages, setLandingPages] = useState<string[]>([]);

  async function fetchWordPressPages(): Promise<void> {
    setIsLoading(true);

    const [apiError, response] = await triadSuperFetch<{
      response: { slug: string }[];
    }>('/api/testing/get-available-landing-pages', {
      method: 'GET',
      timeout: 3000,
      cache: {
        type: 'memory',
        key: 'dev-widget-landing-pages',
      },
      retry: {
        maxAttempts: 5,
        waitTimeBetweenFails: 2000,
      },
    });

    if (apiError) {
      alert(`Failed to fetch landing pages: ${apiError.message}`);
      return;
    }

    setLandingPages(
      response.response.map((page: { slug: string }) => page.slug)
    );

    setIsLoading(false);
  }

  return (
    <section className={styles.section}>
      <div className={styles.buttonGroup}>
        <button
          className={styles.actionButton}
          type="button"
          onClick={fetchWordPressPages}
        >
          <WordPress />
          View WordPress Pages
        </button>
        <button
          className={styles.actionButton}
          type="button"
          onClick={() => alert('coming soon')}
        >
          <APIs />
          API Overrides
        </button>
      </div>
      {isLoading && <div className={styles.loading}>Loading...</div>}
      {!isLoading && landingPages.length > 0 && (
        <div className={styles.landingPages}>
          {landingPages.map((page) => (
            <a key={page} href={`/${page}/landing`}>
              {`/${page}/landing`}
            </a>
          ))}
        </div>
      )}
    </section>
  );
}
